import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IProductVariationDetail } from '@/types/products'

type DataType = {
  data: Omit<IProductVariationDetail, 'id'> | null
}
const initialState: DataType = {
  data: null,
}

const variationSlice = createSlice({
  name: 'productVariation',
  initialState,
  reducers: {
    setProductVariation: (
      state,
      action: PayloadAction<Omit<IProductVariationDetail, 'id'>>
    ) => {
      state.data = action.payload
    },
  },
})

export const { setProductVariation } = variationSlice.actions

export default variationSlice.reducer
